import React from 'react';
import Footer from '../components/Footer';
import CSRelaxIntro from '../components/CSRelaxIntro';
import Contact from './Contact';

const CaseStudyRelax = () => {
    return (
        <>
            <CSRelaxIntro />
            <Contact />
        </>

    )
}

export default CaseStudyRelax;


///<Clients />


